<template>
  <div
    id="calContainer"
    class="vuecal--green-theme"
  >
    <VueCal
      :time-from="timeFrom"
      :time-to="timeTo"
      :disable-views="disabledViews"
      :time-step="timeStep"
      :time="showTime"
      :events="getEvents"
    />
  </div>
</template>

<script>
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';

export default {
  name: 'CommunityCalendar',

  components: {
    VueCal,
  },

  props: {

    disabledViews: {
      type: Array,
      default: () => ['years', 'year'],
    },

    reservations: {
      type: Array,
      required: true,
    },

    //Time settings
    showTime: { 
      type: Boolean, 
      default: undefined, 
    },
    timeFrom: {
      type: Number,
      default: undefined,
    },
    timeStep: {
      type: Number,
      default:undefined,
    },
    timeTo: {
      type: Number,
      default: undefined,
    },
  },

  data: () => ({

  }),

  computed: {
    getEvents() {
      return this.reservations.map(reservation => {
        // console.log(`${reservation.date} ${reservation.start_time.substr(0,5)}`);
        // console.log(`${reservation.date} ${reservation.end_time.substr(0,5)}`);
        // // console.log(reservation);
        return ({
          content: reservation.purpose,
          end: `${reservation.date} ${reservation.end_time.substr(0,5)}`,
          start: `${reservation.date} ${reservation.start_time.substr(0,5)}`,
          title: reservation.user.name,
        });
      });
    },
  },

  created() {
    console.log(this.reservations);
  },


};
</script>

<style>
    #calContainer {
        width: 800px;
        height: 600px;
    }
</style>
